module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAR5JREFUKBWdUj2SRUAY/N7WRgQCoYQSChSZ3A3cxgHcwSEIqBI5A5FISib1U6Wwr2f32XnDJtvJN93TPV99M/M4nqB/4FPMNE1DURSRLMvn1jiOFIYhWZZ1aoSOPNZ1PdI0PbIsOzzPYxUcOo9LEJv7vh9t27IgKriIB4Tf/t+rqqooSRKSJImmaaIgCMh13Tfbxxv7IV3Xka7rlOc5q+AiboMwzfNMtm2zKobAb4PbtpFpmhTHMavgIm6DeJLX1aOCi7gE+76n59Wz2WDGrODQedx+AEVRqCiK0weOrpqmndoluCwLYSZ0eQEcOo9LEO/mOA75vn/6yrKkYRhOjsVlxrquWZB34SDoPC5BwzBIVVXewzh0Hrdfjjf8tf4CgxjUVkwwfgUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/bar-silla.png
// module id = 491
// module chunks = 0